// ─────────────────────────────────────────────────────────────
// General Layout & Breakpoints
// ─────────────────────────────────────────────────────────────
export const HEADER_HEIGHT = 60 as const;

export const SECTIONS = ['בית', 'הסיפור שלי', 'גלריה', 'דברו איתי', 'מידע נוסף', 'ביקורות'] as const;
export type SectionName = (typeof SECTIONS)[number];

export const SEPARATOR_HEIGHT = {
  smallScreen: 5,
  mediumScreen: 5,
  largeScreen: 5,
} as const;

export const MEDIA_BREAKPOINTS = {
  smallScreen: '576px',
  mediumScreen: '769px',
  largeScreen: '1024px',
  desktopScreen: '1440px',  
  ultraWide: '1920px',      
} as const;

export const SHORT_HEIGHT = '700px';
export const ULTRA_NARROW = '380px';
